import {Link} from "react-router-dom";

export const SignatureStrip = () => {
    return (
        // <div className={'signature-strip-container'}>
        //     <Link to={'https://thewickfirm.com/'} target="_blank">Designed & Developed by Wick with ♡</Link>
        // </div>
        <></>
    )
}
